import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormLabel } from './FormLabel';
import ImageUploadModal from '../Modals/imageUploadModal';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import { getWarningSwal } from '../../Services/utils';

const FormProfileImageHandler = ({ control, name, setValue, id, label, rules, imgUrl, replacementImg, ...props }) => {
  const { t } = useTranslation();
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [imgUrlFromProps, setImgUrlFromProps] = useState(imgUrl);

  const [showReplaceDiv, setShowReplaceDiv] = useState(false);

  const doShowReplacementDiv = () => {
    if (replacementImg && imgUrl) return true;
    if (fileToUpload) return true;
    if (replacementImg) return false;

    if (imgUrl) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    doShowReplacementDiv();
    setImgUrlFromProps(imgUrl);
  }, [imgUrl]);

  const setFileToUploadWithValidations = (value) => {
    setFileToUpload(value);
    setShowReplaceDiv(false);
  };

  const deleteFile = () => {
    swal(getWarningSwal()).then((willDelete) => {
      if (willDelete) {
        setValue(name, null, { shouldDirty: true });
        setImgUrlFromProps(null);
        setFileToUpload(null);
        setShowReplaceDiv(false);
        setShowImageUploadModal(false);
      }
    });
  };

  const uploadProfileImage = (files, allFiles) => {
    const fileToUpload = files[0];
    setFileToUpload(fileToUpload);

    setValue(name, fileToUpload, { shouldDirty: true });
    setShowImageUploadModal(!showImageUploadModal);
  };

  const toggleImageUploadModal = () => {
    setShowImageUploadModal(!showImageUploadModal);
    setShowReplaceDiv(doShowReplacementDiv());
  };

  const getImageForDisplay = () => {
    if (fileToUpload?.meta.previewUrl) {
      return fileToUpload?.meta.previewUrl;
    } else if (imgUrlFromProps) {
      return imgUrlFromProps;
    } else {
      if (replacementImg) {
        return replacementImg;
      }
      return 'img/user/user-dummy-300x300.png';
    }
  };

  const getInitialImage = () => {
    if (fileToUpload?.meta.previewUrl) {
      return fileToUpload?.meta.previewUrl;
    } else if (imgUrlFromProps) {
      return imgUrlFromProps;
    } else {
      return null;
    }
  };

  return (
    <div>
      <ImageUploadModal
        showModal={showImageUploadModal}
        onToggle={toggleImageUploadModal}
        numFiles={1}
        onImageSubmit={(files, allFiles) => uploadProfileImage(files, allFiles)}
        initialFileUrl={getInitialImage()}
        setFileToUpload={(value) => setFileToUploadWithValidations(value)}
        showReplaceDiv={showReplaceDiv}
        deleteFile={() => deleteFile()}
      />
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <>
            <div className="img-hover-wrapper" onClick={() => toggleImageUploadModal()}>
              <img
                {...field}
                {...props}
                id={id}
                src={getImageForDisplay()}
                className="img-thumbnail rounded-circle"
                alt={t('common.IMAGE_SHOULD_BE_HERE')}
                style={{ cursor: 'pointer' }}
              />
              <div className="img-hover-overlay">{t('common.HANDLE_IMAGE')}</div>
            </div>
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
          </>
        )}
      />
    </div>
  );
};
export default FormProfileImageHandler;
